import { httpTokenCommon } from "../helper/http-common";

class LoginService {
  loginWithOtkaAuthentication() {
    return "https://reone-api.royalenfield.com/api/auth/saml/login";
  }

  GetUserDetailsByEmailDataAPI() {
    return httpTokenCommon.post("User/userDetails");
  }
  logoutAPI() {
    return httpTokenCommon.post("auth/saml/logout");
  }
}

const loginService = new LoginService();
export default loginService;
